<script lang="ts">
    import type { RewardsStorefrontValuesBrandingEntity } from "@apps/rewards/modules/StorefrontValues/models/RewardsStorefrontValuesEntities";

    export let rewardsBranding: RewardsStorefrontValuesBrandingEntity;

    const {
        general: { theme, buttons },
    } = rewardsBranding;
</script>

<div
    style:--gw-nudges-buttons__theme-color={theme[buttons.themeColor]}
    style:--gw-nudges-buttons__font-color={buttons.fontColor}
>
    <slot />
</div>
